// Local translations
export const T = {
  en_GB: {
    title: "Title (optional)",
    titlePlaceholder: "e.g., Expected Value",
    titleHelp: "Optional heading to display above the expected value",
    description: "Description (optional)",
    descriptionPlaceholder: "Enter description...",
    descriptionHelp: "Optional text to display between the title and content",
    showChart: "Show Chart",
    showChartHelp: "Display line chart showing projected value over time",
    showSummaryTable: "Show Summary Table",
    showSummaryTableHelp: "Yearly summary with deposits, returns, and value",
    compareWithBank: "Compare with bank savings",
    compareWithBankHelp:
      "Show a line for the same cash flows at the collection's flat bank rate (rate set in the portfolio collection's calculation settings)",
    validationError: "At least one display option must be selected",
    componentDescription:
      "This component displays projected portfolio value based on forecasted returns, showing the expected value trajectory over time.",
  },
  nb_NO: {
    title: "Tittel (valgfri)",
    titlePlaceholder: "f.eks. Forventet verdi",
    titleHelp: "Valgfri overskrift som vises over forventet verdi",
    description: "Beskrivelse (valgfri)",
    descriptionPlaceholder: "Skriv inn beskrivelse...",
    descriptionHelp: "Valgfri tekst som vises mellom tittelen og innholdet",
    showChart: "Vis diagram",
    showChartHelp: "Vis linjediagram som viser forventet verdi over tid",
    showSummaryTable: "Vis sammendragstabell",
    showSummaryTableHelp: "Årlig sammendrag med innskudd, avkastning og verdi",
    compareWithBank: "Sammenlign med banksparing",
    compareWithBankHelp:
      "Vis en linje for de samme kontantstrømmene med samlingens flate bankrente (renten settes i porteføljesamlingens beregningsinnstillinger)",
    validationError: "Minst ett visningsalternativ må være valgt",
    componentDescription:
      "Denne komponenten viser forventet porteføljeverdi basert på prognostisert avkastning, og viser forventet verdiutvikling over tid.",
  },
} as const;
